module.exports = __webpack_public_path__ + "static/media/image.06f036ce.svg";